import type { TextEllipsisProps } from '..'

export default (config: { props: Pick<TextEllipsisProps, 'lines'> }) => {
  const { props } = config
  return {
    textEllipsis: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordBreak: props.lines === 1 ? 'break-all' : undefined,
      WebkitLineClamp: props.lines,

      '@supports (-webkit-line-clamp: 1)': {
        whiteSpace: 'normal',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
      },
    },
  } as const
}
